{
    "AddCRMTitle": "Adicionar integração de CRM",
    "ModififyCRMTitle": "Modificar integração de CRM",
    "CRMDetailsTitle": "Detalhes",
    "CRMGeneralIDLabel": "EU IA",
    "CRMDetailsIDLabelPlaceholder": "[Atribuição automática]",
    "CRMDetailsDescriptionLabel": "Descrição",
    "CRMValidationDescriptionLabel": "Descrição é necessária",
    "NAME": "CRMModal",
    "CRMScopeTitle": "Escopo",
    "CRMConfigurationTitle": "Configuração",
    "CRMConfigurationCRMTypeLabel": "CRM",
    "CRMConfigurationTypeNone": "Nenhum",
    "CRMConfigurationTab_Setting_Name": "Nome da configuração",
    "CRMConfigurationTab_Value": "Valor"
}